import { SVGProps } from 'react';

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 6" {...props}>
        <path d="m.305.5 5 5 5-5h-10Z" />
    </svg>
);
export default SvgArrowDown;
